import { findXceedTool } from '@efdigital/ll-admin-v2/utils/lti/products/xceed';
import {
  isPlaceholder,
  platformPhaseStatus,
  toolPhaseStatus,
} from '@efdigital/ll-admin-v2/utils/lti/setup-status';
import type {
  ConsumedTool,
  ConsumedToolDeployment,
  ConsumingPlatform,
} from '@efdigital/ll-cdk-lti-registration-api-types';

export interface ReadyLtiIntegration {
  platform: ConsumingPlatform;
  tool: ConsumedTool;
  deployments: ConsumedToolDeployment[];
}

export function completeDeployments(
  deployments: ConsumedToolDeployment[]
): ConsumedToolDeployment[] {
  return deployments.filter(
    (deployment) => !isPlaceholder(deployment.platformDeploymentId)
  );
}

export function findReadyLtiIntegrations(
  platforms: ConsumingPlatform[],
  toolsByPlatformId: Record<string, ConsumedTool[]>,
  deploymentsByPlatformAndToolId: Record<
    string,
    Record<string, ConsumedToolDeployment[]>
  >
): ReadyLtiIntegration[] {
  const ready: ReadyLtiIntegration[] = [];

  for (const platform of platforms) {
    if (platformPhaseStatus(platform) !== 'complete') {
      continue;
    }

    const tool = findXceedTool(toolsByPlatformId[platform.id] ?? []);
    if (!tool || toolPhaseStatus(tool) !== 'complete') {
      continue;
    }

    const deployments = completeDeployments(
      deploymentsByPlatformAndToolId[platform.id]?.[tool.id] ?? []
    );

    if (deployments.length === 0) {
      continue;
    }

    ready.push({ platform, tool, deployments });
  }

  return ready;
}
